import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import styles from "./editPolicy.module.scss";
import RadioLabel from "./RadioLabel";

const IsEnabled = (): React.JSX.Element => {
  const { formState } = useFormContext();

  return (
    <Form.RadioGroup
      id="enabled"
      label="Enabled"
      isRequired
      name="enabled"
      items={[
        {
          id: "enabled",
          value: "enabled",
          label: (
            <RadioLabel
              label="Yes"
              tooltip="Policy is enabled and will influence final CI/CD status and overall deployment risk."
            />
          ),
        },
        {
          id: "disabled",
          value: "disabled",
          label: (
            <RadioLabel
              label="No"
              tooltip="Policy is disabled and will not be evaluated."
            />
          ),
        },
      ]}
      errors={formState.errors}
      orientation="horizontal"
      radioGroupClassName={styles["radio-group"]}
    />
  );
};

export default IsEnabled;
